<div class="fxg-main-content container-bg">
    <div class="fxg-hero fxg-hero_homepage text-center">
        <span class="title-background">
            <h1>
                {{"HOME.HomeTitlesuffix_Welcome" | translate: {Default: "Welcome"} }} 
                <span class="orange-text">{{userName}}</span> 
                {{"HOME.HomeTitleprefix_Tofedexsupplychaincustomerportal" | translate: {Default: "to FedEx Supply Chain Customer Portal"} }}
            </h1>
        </span>


        <div class="fxg-cube-container">
            <div [ngClass]="{'clickDisabled': notValidUser === true}" class="fxg-cube" appHoverClass="fxg-cube--active" *ngFor="let userModule of userModules">
                <a  
                (click)="onOptionsSelected(userModule.moduleName,userModule.routeUrl)" 
                (mouseover)="userModule.src=userModule.overIcon" (mouseout)="userModule.src=userModule.outIcon">
                    <div class="fxg-cube__content" *ngIf="userModule.moduleName != 'RF'">
                        <img class="" [src]="userModule.src || userModule.outIcon" />
                        <span class="fxg-cube__text" role="tab" aria-label="Operations Management" translate>{{userModule.moduleName}}</span>
                    </div>
                </a>
            </div>
            <span class="fdx-c-button__loading" *ngIf="notValidUser !== false">
                <div class="fdx-c-loading-indicator  fdx-c-loading-indicator--white">
                    <div class="fdx-c-loading-indicator__part"></div>
                    <div class="fdx-c-loading-indicator__part"></div>
                    <div class="fdx-c-loading-indicator__part"></div>
                    <div class="fdx-c-loading-indicator__part"></div>
                </div>
            </span>
        </div>
    </div>

    <div class="none">
        <svg class="fdx-c-icon" aria-hidden="true" focusable="false" role="presentation">
            <use xlink:href="#brand_vacation"></use>
        </svg>
    </div>


    <div class="fdx-c-modal" *ngIf="showCustomerSelectedMsg" style="z-index: 5000;">
        <div class="fdx-c-modal__backdrop"></div>
        <div class="fdx-c-modal__main  fdx-c-modal__main--medium">
            <div class="fdx-c-modal__body">
                <h3 class="fdx-c-modal__title">
                    {{"HOME.HomeInfo_Pleasechooseacustomer" | translate: {Default: "Please choose a customer"} }}
                </h3>
                <div class="fdx-c-modal__description">
                    <div class="row align-items-center fdx-u-mt--4">
                        <div class="col"></div>
                        <div class="col">
                            <a (click)="onClose('showCustomerSelectedMsg')" class="fdx-c-button fdx-c-button--primary fdx-c-button--responsive mr-4 marg-btm-15-at-md">
                                {{"APP.AppButton_Close" | translate: {Default: "CLOSE"} }}
                            </a>
                        </div>
                        <div class="col"></div>
                    </div>
                </div>
            </div>
            <div class="fdx-c-modal__footer">
                <button class="fdx-c-modal__footer__button fdx-c-button fdx-c-button--icon" aria-label="close modal message: lorem ipsum" (click)="onClose('showCustomerSelectedMsg')">
                    <div class="none">
                        <svg class="fdx-c-icon" aria-hidden="true" focusable="false" role="presentation">
                            <use xlink:href="#cross"></use>
                        </svg>
                    </div>
                </button>
            </div>
        </div>
    </div>
    <div class="fdx-c-modal" *ngIf="userNotAuthorized" style="z-index: 5000;">
        <div class="fdx-c-modal__backdrop"></div>
        <div class="fdx-c-modal__main  fdx-c-modal__main--medium">
            <div class="fdx-c-modal__body">
                <h3 class="fdx-c-modal__title">
                    {{"HOME.HomeAuthmodalTitle_Usernotauthorized" | translate: {Default: "User Not authorized"} }}
                </h3>
                <div class="fdx-c-modal__description">
                    <div class="row align-items-center fdx-u-mt--4">
                        <div class="col"></div>
                        <div class="col">
                            <a (click)="onClose('userNotAuthorized')" class="fdx-c-button fdx-c-button--primary fdx-c-button--responsive mr-4 marg-btm-15-at-md">
                                {{"APP.AppButton_Close" | translate: {Default: "CLOSE"} }}
                            </a>
                        </div>
                        <div class="col"></div>
                    </div>
                </div>
            </div>
            <div class="fdx-c-modal__footer">
                <button class="fdx-c-modal__footer__button fdx-c-button fdx-c-button--icon" aria-label="close modal message: lorem ipsum" (click)="onClose('userNotAuthorized')">
                    <div class="none">
                        <svg class="fdx-c-icon" aria-hidden="true" focusable="false" role="presentation">
                            <use xlink:href="#cross"></use>
                        </svg>
                    </div>
                </button>
            </div>
        </div>
    </div>

    <div class="fdx-c-modal" *ngIf="userIsInactive" style="z-index: 5000;">
        <div class="fdx-c-modal__backdrop"></div>
        <div class="fdx-c-modal__main  fdx-c-modal__main--medium">
            <div class="fdx-c-modal__body">
                <h3 class="fdx-c-modal__title">
                    {{"HOME.HomeActivemodalTitle_Userisinactive" | translate: {Default: "User is Inactive"} }}
                </h3>
                <div class="fdx-c-modal__description">
                    <div class="row align-items-center fdx-u-mt--4">
                        <div class="col"></div>
                        <div class="col">
                            <a (click)="onClose('userIsInactive')" class="fdx-c-button fdx-c-button--primary fdx-c-button--responsive mr-4 marg-btm-15-at-md">
                                {{"APP.AppButton_Close" | translate: {Default: "CLOSE"} }}
                            </a>
                        </div>
                        <div class="col"></div>
                    </div>
                </div>
            </div>
            <div class="fdx-c-modal__footer">
                <button class="fdx-c-modal__footer__button fdx-c-button fdx-c-button--icon" aria-label="close modal message: lorem ipsum" (click)="onClose('userIsInactive')">
                    <div class="none">
                        <svg class="fdx-c-icon" aria-hidden="true" focusable="false" role="presentation">
                            <use xlink:href="#cross"></use>
                        </svg>
                    </div>
                </button>
            </div>
        </div>
    </div>



</div>